
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */
import _Link from 'next/link'
import { Heading as _Heading } from '@/components/Heading'
import { DocumentationLayout as _Layout } from '@/layouts/DocumentationLayout'
import { ContentsLayout as _Default } from '@/layouts/ContentsLayout'
const Layout = _Layout;
const meta = {
  "id": "authsystem",
  "title": "Auth Systems",
  "sidebar_label": "Auth Systems"
};
const slug = 'auth';
const tableOfContents = [{
  "title": "Different Login system",
  "slug": "different-login-system",
  "children": []
}, {
  "title": "User Registration",
  "slug": "user-registration",
  "children": []
}];

const layoutProps = {
  Layout,
meta,
slug,
tableOfContents
};
const MDXLayout = _Default
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">






    <_Heading level={2} id={"different-login-system"} nextElement={{
      "type": "paragraph"
    }}>Different Login system</_Heading>
    <p><a parentName="p" {...{
        "href": "https://developer.tradly.app/#276620fb-8503-4a90-8410-00f020d58242"
      }}>{`API REFERENCE`}</a></p>
    <_Heading level={2} id={"user-registration"} nextElement={{
      "type": "paragraph"
    }}>User Registration</_Heading>
    <p>{`If you want to allow users to register for your app and start using your services, there are a few different registration options you can provide. The specific options you choose will depend on the nature of your business and your target audience. Here are some common registration options you may want to consider:`}</p>
    <ul {...{
      "role": "list"
    }}>
      <li parentName="ul">{`Facebook Registration: Users can use their Facebook login to sign up or sign in to your app.`}</li>
      <li parentName="ul">{`Google Registration: Users can use their Google login to sign up or sign in to your app.`}</li>
      <li parentName="ul">{`Email Registration: Users can create an account using an email address that is not connected to a third-party login service.`}</li>
      <li parentName="ul">{`Phone Number-Based Registration(Contact Us for more details): Users can sign up or sign in using their phone number and a one-time password (OTP) for verification. Once the phone number is verified, users can sign in using their phone number and password.`}</li>
    </ul>
    <p>{`Keep in mind that the terms and explanations used in the rest of this documentation will generally be based on the context of typical retail marketplaces.`}</p>



    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
MDXContent.layoutProps = layoutProps
